import { render, staticRenderFns } from "./UOttawaLab2SelfAssessment.vue?vue&type=template&id=100a1410&scoped=true&"
import script from "./UOttawaLab2SelfAssessment.vue?vue&type=script&lang=ts&"
export * from "./UOttawaLab2SelfAssessment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100a1410",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VForm,VSimpleTable,VTextField})
